import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// polyfill for IE11 for urlsearchparams
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import './assets/fonts/fonts.css';
import { App } from './App';
import * as serviceWorker from './serviceWorker';
import { HelmetProvider } from 'react-helmet-async';
import { CookiesProvider } from 'react-cookie';

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
